import { HTMLMotionProps, motion } from "framer-motion"

interface AnimatedEnteringBlockType extends HTMLMotionProps<"div"> {
  children: any,
  layout?: boolean, 
  slideX?: boolean,
}
const AnimatedEnteringBlock = React.forwardRef<HTMLDivElement, AnimatedEnteringBlockType>(({ children, layout = false, slideX = true, ...props}, ref) => {
  return (
    <motion.div  
      ref={ref}
      layout={layout}
      initial={{scale: 1.1, opacity: 0 }}
      animate={{scale: 1, opacity: 1 }}
      exit={{scale: 0.9, opacity: 0 }}
      transition={{ease: "easeOut", duration: 0.2}}
      {...props}
      >
        {children}
    </motion.div>
  )
})

export default AnimatedEnteringBlock
